import React from "react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

import { SchoolPages, MarkingColors, MarkingOutcome, Subjects, Common } from "../../helper";
import { isEmptyArray } from "../../util";
import { LoadingSpinner } from "../Shared";
import { setId, setAssessmentYear, setFirstName, setPupilId, setLastName, setLatestAssessment, setAddNewAssessment } from "../../store/assessmentSlice.js"

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import WritingSvg from "../../assets/images/WritingClassHome.svg"

const ClassHomeWritting = (props) => {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const { subject, pupil, index, subjectActualAverages, subjectPredictedAverages, subjectActualOutcomeAverages, subjectPredictedOutcomeAverages, assessment, assmtAddDisable, year, isLoading } = props;
  const tableData = pupil && [...pupil]
  tableData?.unshift([subjectActualAverages, subjectPredictedAverages])
  let bgClass = index % 2 === 0 ? "classHomeSubject-container-bg-light" : "classHomeSubject-container-bg-dark"
  let bgColourClassName = `classHomeWriting-container ${bgClass}`

  const markingColour = (marking, asstdata) => {
    let bg = "none"
    if (asstdata?.year === 6 || asstdata?.year === 2) {
      if (!marking) {
        bg = "var(--absent-colour)"
      }
      else {
        let last = marking[1]
        bg = last === "B" ? "var(--below-colour)" : last === "W" ? "var(--emerging-colour)" : last === "E" ? "var(--expected-colour)" : "var(--greater-colour)"
      }
    } else {
      if (!marking) {
        bg = "var(--absent-colour)"
      }
      else {
        console.log("marking.slice(1)", MarkingOutcome)
        switch (marking.slice(1)) {
        case MarkingOutcome.G_Secure: bg = MarkingColors.GreaterDepth
          break;
        case MarkingOutcome.G_GoodFit: bg = MarkingColors.GreaterDepth
          break;
        case MarkingOutcome.E_Secure: bg = MarkingColors.Expected
          break;
        case MarkingOutcome.E_GoodFit: bg = MarkingColors.Expected
          break;
        case MarkingOutcome.E_Just: bg = MarkingColors.Expected
          break;
        case MarkingOutcome.W_Secure: bg = MarkingColors.Emerging
          break;
        case MarkingOutcome.W_GoodFit: bg = MarkingColors.Emerging
          break;
        case MarkingOutcome.W_Just: bg = MarkingColors.Emerging
          break;
        case MarkingOutcome.Below: bg = MarkingColors.Below
          break;
        default: bg = MarkingColors.Absent
        }
      }
    }
    return bg
  }

  const classAvgMarkingColour = (marking) => {
    switch (marking[1]) {
    case "B":
      return MarkingColors.Below;
    case "G":
      return MarkingColors.GreaterDepth;
    case "E":
      return MarkingColors.Expected;
    case "W":
      return MarkingColors.Emerging;
    default:
      return MarkingColors.Absent;
    }
  };

  const handleTeacherAssessmentNew = (e) => {
    dispatch(setFirstName(e.firstName))
    dispatch(setLastName(e.lastName))
    dispatch(setAssessmentYear(e.year))
    dispatch(setPupilId(e.id))
    dispatch(setLatestAssessment([]))
    dispatch(setAddNewAssessment(true))
    navigate(SchoolPages.Assessment)
  }

  const handleTeacherAssessment = (latestAssessment, e) => {
    dispatch(setFirstName(e.firstName))
    dispatch(setLastName(e.lastName))
    dispatch(setAssessmentYear(e.year))
    dispatch(setPupilId(e.id))
    dispatch(setAddNewAssessment(false))
    dispatch(setLatestAssessment(latestAssessment))
    dispatch(setId(latestAssessment[0].assessmentId))
    navigate(SchoolPages.Assessment)
  }

  const getLatestOutcome = (latestOutcome, asstdata) => {
    if (asstdata.year === 2 || asstdata.year === 6) {
      return latestOutcome
    } else {
      return `${latestOutcome.slice(0, 2)}`
    }
  }

  const teachersColour = (outcome) => {
    let bg = "none"
    switch (outcome) {
    case `Year ${year} Greater Depth`: bg = MarkingColors.GreaterDepth
      break;
    case `Year ${year} Expected Standard`: bg = MarkingColors.Expected
      break;
    case `Year ${year} Working Towards`: bg = MarkingColors.Emerging
      break;
    case `Year ${year} Below`: bg = MarkingColors.Below
      break;
    default: bg = MarkingColors.Below
    }
    return bg
  }

  return (
    <>
      {isLoading ? <LoadingSpinner /> : <div className={`${bgColourClassName} classHomeSubject-fix-${index}`} key={index}>
        <div className="classHomeWritting-classHead-th">
          <div className="classHome-mathsIcon-subject">
            <img className="classHome-mathsIcon" src={`${WritingSvg}`} alt="Maths" /><span className="classHome-maths-span">{Subjects.Writing}</span>
          </div>
        </div>
        <table className="your-table-class-subject">
          <thead>
            <tr className="classHomeSubject-trAvg" >
              <td className="classHomeSubject-td">
                <div className="KS-container" style={{ borderRight: "none" }}>
                  <div className="greenPointer" ></div>
                  <span className="KS1"></span>
                </div>
              </td>
              <td className="classAverage-td">
                <span className="currentScoreAvgWriting">
                  <span className="currentScoreMarkingAvg" ><span className="currentScoreMarkinTextAvg">{Common.Current}</span></span><span className="currentScorePercentage"></span>
                </span>
                <span className="predictedScoreAvg">
                  <span className="predictedScoreMarkingAvg" ><span className="predictedScoreMarkinTextAvg">{Common.Predicted}</span></span><span className="predictedScorePercentage"></span>
                </span>
                <span className="teachersAssessment">
                  <div className="currentScoreMarkinTextAvg">
                    {Common.TeachersAssessments}
                  </div>
                </span>
                <span style={{ width: "70px" }}></span>
              </td>
            </tr>
          </thead>
          <tbody className="classHomeSubject-body">
            {
              tableData && tableData.map((asstdata, i) => {
                if (i === 0) {
                  let current = asstdata[0][subject.subject] ? asstdata[0][subject.subject] : asstdata[1]["PhysicalEducation"]
                  let predicted = asstdata[1][subject.subject] ? asstdata[1][subject.subject] : asstdata[1]["PhysicalEducation"]
                  let currentMarking = subjectActualOutcomeAverages ? subjectActualOutcomeAverages[subject.subject] : subjectActualOutcomeAverages["PhysicalEducation"]
                  let predictedMarking = subjectPredictedOutcomeAverages ? subjectPredictedOutcomeAverages[subject.subject] : subjectPredictedOutcomeAverages["PhysicalEducation"]

                  return (
                    <tr className="classHomeSubject-tr" key={i}>
                      <td className="classHomeSubject-td">
                        <div className="KS-container">
                          <div className="greenPointer"></div>
                          <span className="KS1"></span>
                        </div>
                      </td>
                      <td className="writing-average">
                        <span className="currentScore">
                          <span className="currentScoreMarking" style={{ backgroundColor: classAvgMarkingColour(currentMarking) }}><span className="currentScoreMarkinText">{currentMarking ? currentMarking.split("-")[0] : "-"}</span></span><span className="currentScorePercentage">{current ? `${Math.round(current)}%` : "0%"}</span>
                        </span>
                        <span className="predictedScore">
                          <span className="predictedScoreMarking" style={{ backgroundColor: classAvgMarkingColour(predictedMarking) }}><span className="predictedScoreMarkinText">{predictedMarking ? predictedMarking.split("-")[0] : "-"}</span></span><span className="predictedScorePercentage">{predicted ? `${Math.round(predicted)}%` : "0%"}</span>
                        </span>
                        <span><span className="assessment-leftMarking"></span></span>
                        <span style={{ color: "#fafafa", width: "70px" }} >hi</span>
                      </td>

                    </tr>
                  )
                } else {
                  const ks1 = asstdata.ksResult[subject.subject]
                  const outcome = asstdata.subject.find(s => s.name === subject.subject)
                  let assessments = assessment && assessment.filter(asmt => asmt.pupilId === asstdata.id)[0]?.assessment
                  let latestAssessment = assessments?.length ? [assessments[0]] : []
                  let current = "";
                  let predicted = "";
                  let currentMarking = "";
                  let predictedMarking = "";

                  if (outcome) {
                    if (outcome.actual !== undefined) {
                      current = outcome.actual;
                    }
                    if (outcome.predicted !== undefined) {
                      predicted = outcome.predicted;
                    }
                    if (outcome.actualOutcome !== undefined) {
                      currentMarking = outcome.actualOutcome;
                    }
                    if (outcome.predictedOutcome !== undefined) {
                      predictedMarking = outcome.predictedOutcome;
                    }
                  }

                  return (
                    <tr className="classHomeSubject-tr" key={i}>
                      <td className="classHomeSubject-td">
                        <div className="KS-container">
                          <div className="greenPointer" style={{ backgroundColor: ks1?.charAt(ks1.length - 1).toUpperCase() === "M" ? "var(--expected-colour)" : ks1?.charAt(ks1.length - 1).toUpperCase() === "L" ? "var(--emerging-colour)" : ks1?.charAt(ks1.length - 1).toUpperCase() === "H" ? "var(--greater-colour)" : "#A8A7A7" }}></div>
                          <span className="KS1">{ks1}</span>
                        </div>
                      </td>
                      <td className="classAverage-td">
                        <span className="currentScore">
                          <span className="currentScoreMarking" style={{ backgroundColor: classAvgMarkingColour(currentMarking) }}><span className="currentScoreMarkinText">{currentMarking.split("-")[0]}</span></span><span className="currentScorePercentage">{`${Math.round(current)}%`}</span>
                        </span>
                        <span className="predictedScore">
                          <span className="predictedScoreMarking" style={{ backgroundColor: classAvgMarkingColour(predictedMarking) }}><span className="predictedScoreMarkinText">{predictedMarking.split("-")[0]}</span></span><span className="predictedScorePercentage">{`${Math.round(predicted)}%`}</span>
                        </span>
                        <span>
                          {
                            isEmptyArray(latestAssessment) ? (
                              <div className="assessment-leftMarking assessment-leftMarking-bg-null">
                                <span className="assessment-leftTextDraft">
                                  <br /><span className="dateDraft"></span>
                                </span>
                              </div>
                            ) : (
                              latestAssessment[0]?.isSubmited ? (
                                latestAssessment[0].outcome ? (
                                  <button onClick={() => { handleTeacherAssessment(latestAssessment, asstdata) }} className="assessment-leftMarking " style={{ backgroundColor: latestAssessment[0]?.outcome.includes("Year") ? teachersColour(latestAssessment[0]?.outcome) : markingColour(latestAssessment[0]?.outcome, asstdata) }}>
                                    <span className="assessment-leftText">{latestAssessment[0]?.outcome.includes("Year") ? (latestAssessment[0]?.outcome[5] + latestAssessment[0]?.outcome[7]) : getLatestOutcome(latestAssessment[0]?.outcome, asstdata
                                    ).slice(0, 2)}<br /><span className="date">{latestAssessment[0]?.outcome ? latestAssessment[0].date : ""}</span></span>
                                  </button>
                                ) : (
                                  <button onClick={() => { handleTeacherAssessment(latestAssessment, asstdata) }} className="assessment-leftMarking assessment-leftMarking-bg-null">
                                    <span className="assessment-leftText">
                                      <br /><span className="date"></span>
                                    </span>
                                  </button>
                                )
                              ) : (
                                latestAssessment[0]?.outcome ? (
                                  <button disabled={!assmtAddDisable} onClick={() => { handleTeacherAssessment(latestAssessment, asstdata) }} className="assessment-leftMarking assessment-leftMarking-bg-cream">
                                    <span className="assessment-leftTextDraft">
                                      Draft
                                      <br /><span className="dateDraft">{latestAssessment[0]?.outcome ? latestAssessment[0].date : ""}</span>
                                    </span>
                                  </button>
                                ) : (
                                  <div className="assessment-leftMarking assessment-leftMarking-bg-null">
                                    <span className="assessment-leftTextDraft">
                                      <br /><span className="dateDraft"></span>
                                    </span>
                                  </div>
                                )
                              )
                            )
                          }
                        </span>
                        {
                          !assmtAddDisable ? <span></span> : <span className="addButton" ><button style={{ background: "none" }} onClick={() => { handleTeacherAssessmentNew(asstdata) }}><AddCircleOutlineIcon fill={"var(--primary-button-color)"} /></button></span>
                        }
                      </td>
                    </tr>
                  )
                }
              })
            }
          </tbody>
        </table>
      </div>}
    </>
  )
}

export { ClassHomeWritting };